import React from 'react';
import { Badge } from './ui/Badge';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    name: 'Roberto Martínez',
    role: 'Director General, Constructora del Norte',
    content: 'El proceso fue increíblemente rápido. En menos de 48 horas teníamos la aprobación y pudimos renovar nuestra flotilla completa.',
    rating: 5
  }, {
    name: 'Ana Gutiérrez',
    role: 'CFO, TechSolutions México',
    content: 'La deducibilidad del 100% nos permitió optimizar nuestra carga fiscal. El equipo de ArrendaLogic nos asesoró en todo momento.',
    rating: 5
  }, {
    name: 'Carlos Hernández',
    role: 'Propietario, Transportes Hernández',
    content: 'Financiamos 5 tractocamiones sin afectar nuestro flujo de efectivo. Excelente servicio y tasas competitivas.',
    rating: 5
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-280">
      <div className="max-w-7xl mx-auto" data-id="element-281">
        <div className="text-center mb-12" data-id="element-282">
          <Badge variant="success" className="mb-4" data-id="element-283">
            Testimonios
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-284">
            Empresas que confían en nosotros
          </h2>
          <p className="text-xl text-slate-600" data-id="element-285">
            Más de 1,000 empresas han optimizado su operación con ArrendaLogic
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-286">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-slate-200" data-id="element-287">
              <div className="flex items-center gap-1 mb-4" data-id="element-288">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-warning text-warning" data-id="element-289" />)}
              </div>

              <QuoteIcon className="w-8 h-8 text-primary-200 mb-3" data-id="element-290" />

              <p className="text-slate-700 mb-4 leading-relaxed" data-id="element-291">
                "{testimonial.content}"
              </p>

              <div className="pt-4 border-t border-slate-200" data-id="element-292">
                <p className="font-semibold text-slate-900" data-id="element-293">
                  {testimonial.name}
                </p>
                <p className="text-sm text-slate-600" data-id="element-294">{testimonial.role}</p>
              </div>
            </div>)}
        </div>

        {/* Client logos */}
        <div className="text-center" data-id="element-295">
          <p className="text-sm text-slate-600 mb-6 font-medium" data-id="element-296">
            Empresas que han confiado en nosotros
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 opacity-60" data-id="element-297">
            {['Empresa A', 'Empresa B', 'Empresa C', 'Empresa D', 'Empresa E'].map((company, index) => <div key={index} className="bg-slate-200 rounded-lg px-8 py-4" data-id="element-298">
                <span className="text-slate-600 font-semibold" data-id="element-299">{company}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}